/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { ColoredFeature } from "./types";

export default function Colored(feature: ColoredFeature) {
  let setColorAction = feature.actions.set_color;

  this.set("color", feature.colors);

  return (this.syncColor = () => {
    return this.executeDeviceAction(setColorAction, this.get("color"), {
      updateModelWithResponse: false,
    });
  });
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/colored.js